// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables from assets */
:root {
  --primary: #e84200;
  --darkgrey1: #222222;
  --darkgrey3: #000000;
  --grey1: #d7d7d7;
  --grey4: #a1a1a1;
  --white: #ffffff;
  --dim20: rgba(0, 0, 0, 0.2);
}

.login-panel-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--dim20);
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.login-panel-overlay.open {
    opacity: 1;
    visibility: visible;
}

.login-panel {
    width: 536px;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    background-color: var(--white);
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1001;
    display: flex;
    flex-direction: column;
}

.login-panel.open {
    transform: translateX(0);
}

.login-panel-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    position: relative;
}

.offcanvas-tit {
    display: flex;
    flex-direction: column;
    gap: 22px;
    align-items: center;
    justify-content: flex-start;
    width: 450px;
    padding: 65px 43px 0 43px;
}

.login-title-section {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.login-icon {
    flex-shrink: 0;
    width: 45px;
    height: 45px;
    position: relative;
    overflow: visible;
    aspect-ratio: 1;
}

.login-panel-header h2 {
    color: var(--darkgrey3);
    text-align: left;
    font-family: "Inter-Bold", sans-serif;
    font-size: 28px;
    font-weight: 700;
    margin: 0;
    position: relative;
}

.header-divider {
    margin-top: -1px;
    border-style: solid;
    border-color: var(--darkgrey1);
    border-width: 1px 0 0 0;
    align-self: stretch;
    flex-shrink: 0;
    height: 0px;
    position: relative;
}

.login-panel .close-button {
    background: transparent;
    border: none;
    width: 54px;
    height: 54px;
    cursor: pointer;
    position: absolute;
    top: 26px;
    left: -81px;
    padding: 0;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-button-circle {
    background: var(--white);
    border-radius: 50%;
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.close-button-circle img {
    width: 30px;
    height: 30px;
}

.login-panel.open .close-button {
    opacity: 1;
}

.login-panel-body {
    padding: 40px 43px;
    overflow-y: auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.login-form-wrapper,
.register-form-wrapper {
    display: flex;
    flex-direction: column;
    gap: 28px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 450px;
}

.login-form-container,
.register-form-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 9px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.form-group label {
    color: var(--darkgrey3);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
    position: relative;
    align-self: stretch;
}

.form-group input {
    background: var(--white);
    border-radius: 10px;
    border-style: solid;
    border-color: var(--grey1);
    border-width: 1px;
    width: 450px;
    height: 53px;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    color: var(--darkgrey3);
}

.form-group input::placeholder {
    color: var(--grey4);
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
}

.login-options {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.remember-me {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: var(--darkgrey3);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
    position: relative;
}

.remember-me input {
    margin-right: 8px;
    width: auto;
    height: auto;
}

.find-credentials {
    color: var(--darkgrey3);
    text-align: right;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
    text-decoration: none;
    position: relative;
}

.login-actions,
.register-actions {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.btn-login,
.btn-new-registration,
.btn-register-next {
    background: var(--darkgrey1);
    border-radius: 10px;
    padding: 4px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    flex-shrink: 0;
    height: 62px;
    position: relative;
    border: none;
    cursor: pointer;
}

.btn-login,
.btn-new-registration,
.btn-register-next {
    color: var(--white);
    text-align: center;
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
}

.btn-login div,
.btn-new-registration div,
.btn-register-next div {
    color: var(--white);
    text-align: center;
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
    position: relative;
}

.btn-new-registration {
    background: var(--primary);
}

.btn-register-next {
    background: var(--darkgrey1);
}

.btn-login:disabled,
.btn-new-registration:disabled,
.btn-register-next:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.login-error-message {
    color: #ff4444;
    font-size: 14px;
    margin-bottom: 10px;
    text-align: center;
    font-family: "Inter-Medium", sans-serif;
}

/* Register form specific styles */
.register-info-sections {
    display: flex;
    flex-direction: column;
    gap: 60px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
    margin-top: 150px;
}

.info-section {
    display: flex;
    flex-direction: column;
    gap: 13px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.info-section-header {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.info-section-header h3 {
    color: var(--darkgrey3);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    position: relative;
    align-self: stretch;
    margin: 0;
}

.info-divider {
    margin-top: -1px;
    border-style: solid;
    border-color: var(--darkgrey1);
    border-width: 1px 0 0 0;
    align-self: stretch;
    flex-shrink: 0;
    height: 0px;
    position: relative;
}

.info-section-content {
    color: var(--darkgrey3);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
    position: relative;
    align-self: stretch;
    line-height: 1.6;
}

.logged-in-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.user-welcome {
    padding: 30px 10px;
    text-align: left;
}

.user-welcome p {
    margin: 0;
    font-size: 22px;
    line-height: 1.5;
}

.user-welcome p strong {
    font-weight: bold;
}

.my-page-menu {
    display: flex;
    flex-direction: column;
}

.menu-item {
    padding: 15px 54px;
    font-size: 18px;
    color: #333;
    text-decoration: none;
    border-bottom: 1px solid #f0f0f0;
}

.menu-item:first-child {
    border-top: 1px solid #f0f0f0;
}

.menu-item.active {
    background-color: #f9f9f9;
    color: #E84100;
    position: relative;
}

.menu-item.active::before {
    content: '●';
    color: #E84100;
    position: absolute;
    left: 30px;
    font-size: 12px;
}

.menu-item:hover {
    color: #000;
}

/* Mobile devices */
@media (max-width: 768px) {
    .login-panel {
        width: 100%;
    }

    .login-panel .close-button {
        top: 15px;
        right: 15px;
        left: auto;
        opacity: 1;
        background: transparent;
        border: none;
        box-shadow: none;
    }

    .close-button-circle {
        background: transparent;
        box-shadow: none;
    }

    .close-button-circle img {
        width: 24px;
        height: 24px;
    }
    
    .login-panel-header {
        padding: 0;
    }

    .offcanvas-tit {
        width: 100%;
        padding: 20px;
        gap: 15px;
    }

    .login-panel-body {
        padding: 20px;
    }

    .login-form-wrapper,
    .register-form-wrapper {
        width: 100%;
    }

    .form-group input {
        width: 100%;
    }

    .register-info-sections {
        margin-top: 40px;
        gap: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/css/LoginPanel.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,MAAM;IACN,QAAQ;IACR,8BAA8B;IAC9B,yCAAyC;IACzC,2BAA2B;IAC3B,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,UAAU;IACV,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,uCAAuC;IACvC,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,4BAA4B;IAC5B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,WAAW;QACX,UAAU;QACV,UAAU;QACV,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,aAAa;QACb,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ","sourcesContent":["/* CSS Variables from assets */\n:root {\n  --primary: #e84200;\n  --darkgrey1: #222222;\n  --darkgrey3: #000000;\n  --grey1: #d7d7d7;\n  --grey4: #a1a1a1;\n  --white: #ffffff;\n  --dim20: rgba(0, 0, 0, 0.2);\n}\n\n.login-panel-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--dim20);\n    z-index: 1000;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n}\n\n.login-panel-overlay.open {\n    opacity: 1;\n    visibility: visible;\n}\n\n.login-panel {\n    width: 536px;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    right: 0;\n    background-color: var(--white);\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n    z-index: 1001;\n    display: flex;\n    flex-direction: column;\n}\n\n.login-panel.open {\n    transform: translateX(0);\n}\n\n.login-panel-header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0;\n    position: relative;\n}\n\n.offcanvas-tit {\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n    align-items: center;\n    justify-content: flex-start;\n    width: 450px;\n    padding: 65px 43px 0 43px;\n}\n\n.login-title-section {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    justify-content: flex-start;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.login-icon {\n    flex-shrink: 0;\n    width: 45px;\n    height: 45px;\n    position: relative;\n    overflow: visible;\n    aspect-ratio: 1;\n}\n\n.login-panel-header h2 {\n    color: var(--darkgrey3);\n    text-align: left;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 28px;\n    font-weight: 700;\n    margin: 0;\n    position: relative;\n}\n\n.header-divider {\n    margin-top: -1px;\n    border-style: solid;\n    border-color: var(--darkgrey1);\n    border-width: 1px 0 0 0;\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 0px;\n    position: relative;\n}\n\n.login-panel .close-button {\n    background: transparent;\n    border: none;\n    width: 54px;\n    height: 54px;\n    cursor: pointer;\n    position: absolute;\n    top: 26px;\n    left: -81px;\n    padding: 0;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.close-button-circle {\n    background: var(--white);\n    border-radius: 50%;\n    width: 54px;\n    height: 54px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.close-button-circle img {\n    width: 30px;\n    height: 30px;\n}\n\n.login-panel.open .close-button {\n    opacity: 1;\n}\n\n.login-panel-body {\n    padding: 40px 43px;\n    overflow-y: auto;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.login-form-wrapper,\n.register-form-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 450px;\n}\n\n.login-form-container,\n.register-form-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.form-group label {\n    color: var(--darkgrey3);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    position: relative;\n    align-self: stretch;\n}\n\n.form-group input {\n    background: var(--white);\n    border-radius: 10px;\n    border-style: solid;\n    border-color: var(--grey1);\n    border-width: 1px;\n    width: 450px;\n    height: 53px;\n    padding: 0 16px;\n    box-sizing: border-box;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    color: var(--darkgrey3);\n}\n\n.form-group input::placeholder {\n    color: var(--grey4);\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n}\n\n.login-options {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.remember-me {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    color: var(--darkgrey3);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    position: relative;\n}\n\n.remember-me input {\n    margin-right: 8px;\n    width: auto;\n    height: auto;\n}\n\n.find-credentials {\n    color: var(--darkgrey3);\n    text-align: right;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    text-decoration: none;\n    position: relative;\n}\n\n.login-actions,\n.register-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.btn-login,\n.btn-new-registration,\n.btn-register-next {\n    background: var(--darkgrey1);\n    border-radius: 10px;\n    padding: 4px;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 62px;\n    position: relative;\n    border: none;\n    cursor: pointer;\n}\n\n.btn-login,\n.btn-new-registration,\n.btn-register-next {\n    color: var(--white);\n    text-align: center;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.btn-login div,\n.btn-new-registration div,\n.btn-register-next div {\n    color: var(--white);\n    text-align: center;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    position: relative;\n}\n\n.btn-new-registration {\n    background: var(--primary);\n}\n\n.btn-register-next {\n    background: var(--darkgrey1);\n}\n\n.btn-login:disabled,\n.btn-new-registration:disabled,\n.btn-register-next:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.login-error-message {\n    color: #ff4444;\n    font-size: 14px;\n    margin-bottom: 10px;\n    text-align: center;\n    font-family: \"Inter-Medium\", sans-serif;\n}\n\n/* Register form specific styles */\n.register-info-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 60px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n    margin-top: 150px;\n}\n\n.info-section {\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.info-section-header {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.info-section-header h3 {\n    color: var(--darkgrey3);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    position: relative;\n    align-self: stretch;\n    margin: 0;\n}\n\n.info-divider {\n    margin-top: -1px;\n    border-style: solid;\n    border-color: var(--darkgrey1);\n    border-width: 1px 0 0 0;\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 0px;\n    position: relative;\n}\n\n.info-section-content {\n    color: var(--darkgrey3);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    position: relative;\n    align-self: stretch;\n    line-height: 1.6;\n}\n\n.logged-in-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.user-welcome {\n    padding: 30px 10px;\n    text-align: left;\n}\n\n.user-welcome p {\n    margin: 0;\n    font-size: 22px;\n    line-height: 1.5;\n}\n\n.user-welcome p strong {\n    font-weight: bold;\n}\n\n.my-page-menu {\n    display: flex;\n    flex-direction: column;\n}\n\n.menu-item {\n    padding: 15px 54px;\n    font-size: 18px;\n    color: #333;\n    text-decoration: none;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.menu-item:first-child {\n    border-top: 1px solid #f0f0f0;\n}\n\n.menu-item.active {\n    background-color: #f9f9f9;\n    color: #E84100;\n    position: relative;\n}\n\n.menu-item.active::before {\n    content: '●';\n    color: #E84100;\n    position: absolute;\n    left: 30px;\n    font-size: 12px;\n}\n\n.menu-item:hover {\n    color: #000;\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .login-panel {\n        width: 100%;\n    }\n\n    .login-panel .close-button {\n        top: 15px;\n        right: 15px;\n        left: auto;\n        opacity: 1;\n        background: transparent;\n        border: none;\n        box-shadow: none;\n    }\n\n    .close-button-circle {\n        background: transparent;\n        box-shadow: none;\n    }\n\n    .close-button-circle img {\n        width: 24px;\n        height: 24px;\n    }\n    \n    .login-panel-header {\n        padding: 0;\n    }\n\n    .offcanvas-tit {\n        width: 100%;\n        padding: 20px;\n        gap: 15px;\n    }\n\n    .login-panel-body {\n        padding: 20px;\n    }\n\n    .login-form-wrapper,\n    .register-form-wrapper {\n        width: 100%;\n    }\n\n    .form-group input {\n        width: 100%;\n    }\n\n    .register-info-sections {\n        margin-top: 40px;\n        gap: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
